import { render, staticRenderFns } from "./BotaoDoChatDeSuporte.vue?vue&type=template&id=24afaa97&scoped=true&"
import script from "./BotaoDoChatDeSuporte.vue?vue&type=script&lang=ts&"
export * from "./BotaoDoChatDeSuporte.vue?vue&type=script&lang=ts&"
import style0 from "./BotaoDoChatDeSuporte.vue?vue&type=style&index=0&id=24afaa97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24afaa97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
